import { get_token } from "@/router";
import Swal from "sweetalert2";

function get_payfast_headers() {
  return {
    Authorization: `Token ${get_token()}`,
    "Content-Type": "application/json",
  };
}

function get_empty_payfast_form(company_id = null) {
  return {
    company_id,
    merchant_id: "",
    merchant_key: "",
    passphrase: "",
  };
}

export function get_organisation_payfast_data() {
  return ({
    payfast_config: null,
    payfast_form: get_empty_payfast_form(),
    payfast_loading: false,
    payfast_saving: false,
    payfast_error: "",
    show_payfast_passphrase: false,
    show_payfast_merchant_key: false,
  });
}

export const organisationPayfastMethods = {
  reset_payfast_state() {
    this.payfast_config = null;
    this.payfast_form = get_empty_payfast_form(this.organization_company_id);
    this.payfast_error = "";
    this.payfast_loading = false;
    this.payfast_saving = false;
    this.show_payfast_passphrase = false;
    this.show_payfast_merchant_key = false;
  },
  build_payfast_payload() {
    return ({
      company_id: this.organization_company_id,
      merchant_id: this.payfast_form.merchant_id,
      merchant_key: this.payfast_form.merchant_key,
      passphrase: this.payfast_form.passphrase,
    });
  },
  apply_payfast_response(response) {
    this.payfast_config = response?.data;
    this.payfast_form = {
      company_id: this.organization_company_id,
      merchant_id: this.payfast_config?.merchant_id || "",
      merchant_key: this.payfast_config?.merchant_key || "",
      passphrase: this.payfast_config?.passphrase || "",
    };
  },
  fetch_payfast_config() {
    if (!this.organization_company_id || !get_token()) {
      return;
    }

    this.payfast_loading = true;
    this.payfast_error = "";

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/organisation/get_payment_account_config/?company_id=${this.organization_company_id}`,
      type: "GET",
      headers: get_payfast_headers(),
      success: (response) => {
        this.apply_payfast_response(response);
      },
      error: (xhr) => {
        if (xhr?.status === 404) {
          this.payfast_config = null;
          this.payfast_form = get_empty_payfast_form(this.organization_company_id);
          return;
        }

        this.payfast_error = xhr?.responseJSON?.message || "Could not load payment account settings.";
      },
      complete: () => {
        this.payfast_loading = false;
      },
    });
  },
  save_payfast_config() {
    if (!this.organization_company_id || !get_token()) {
      return;
    }

    this.payfast_saving = true;
    this.payfast_error = "";

    const has_payfast_config = !!this.payfast_config?.id;

    $.ajax({
      url: has_payfast_config
        ? `${process.env.VUE_APP_BACKEND_API_URL}/organisation/update_payment_account_config/`
        : `${process.env.VUE_APP_BACKEND_API_URL}/organisation/create_payment_account_config/`,
      type: "POST",
      headers: get_payfast_headers(),
      data: JSON.stringify(this.build_payfast_payload()),
      success: (response) => {
        this.apply_payfast_response(response);
        Swal.fire({
          icon: "success",
          title: has_payfast_config ? "Payment account updated." : "Payment account created.",
          showConfirmButton: false,
          timer: 2200,
          position: "bottom-end",
          toast: true,
        });
      },
      error: (xhr) => {
        this.payfast_error = xhr?.responseJSON?.message || "Could not save payment account settings.";
      },
      complete: () => {
        this.payfast_saving = false;
      },
    });
  },
  delete_payfast_config() {
    if (!this.organization_company_id || !get_token()) {
      return;
    }

    this.payfast_error = "";

    Swal.fire({
      icon: "warning",
      title: "Delete payment account?",
      text: "This will remove the saved payment account configuration for this organisation.",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      position: "bottom-end",
      toast: true,
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.payfast_saving = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/organisation/delete_payment_account_config/`,
        type: "DELETE",
        headers: get_payfast_headers(),
        data: JSON.stringify({ company_id: this.organization_company_id }),
        success: () => {
          this.payfast_config = null;
          this.payfast_form = get_empty_payfast_form(this.organization_company_id);
          Swal.fire({
            icon: "success",
            title: "Payment account deleted.",
            showConfirmButton: false,
            timer: 2200,
            position: "bottom-end",
            toast: true,
          });
        },
        error: (xhr) => {
          this.payfast_error = xhr?.responseJSON?.message || "Could not delete payment account settings.";
        },
        complete: () => {
          this.payfast_saving = false;
        },
      });
    });
  },
};


